import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormDataService } from '../shared/form-data.service';
import { ConfigService } from '../shared/config.service';

@Component({
  selector: 'app-intermediate-easyclaim-tl',
  templateUrl: './intermediate-easyclaim-tl.component.html',
  styleUrls: ['./intermediate-easyclaim-tl.component.scss']
})
export class IntermediateEasyclaimTLComponent implements OnInit {
  showSpinner: boolean;
  contentDetail: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private configService: ConfigService,
    private formDataService: FormDataService,
  ) { 
      this.contentDetail = this.configService.config.Data.contentDetail;
  }

  ngOnInit() {
  }

  acceptOffer() {
    
    this.formDataService.setIsEasyClaimTlAcceptType(true);

    this.router.navigate(['../questions'], { relativeTo: this.route });
  }

  declineOffer() {       
    this.formDataService.setIsEasyClaimTlAcceptType(false);
    // this.router.navigate(['../main/photos'], {relativeTo: this.route});
    this.router.navigate(['../main/questions'], {relativeTo: this.route});
  }

}
